import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "../pages/Login";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate
} from "@azure/msal-react";
import VerifyUsers from "./VerifyUsers";
const SigninWidget = () => {




  return (
    <div>
      <AuthenticatedTemplate>
        <VerifyUsers />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>

    </div>
  )
}

export default SigninWidget

